/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type Error404UmbPageContentModelContentType =
	(typeof Error404UmbPageContentModelContentType)[keyof typeof Error404UmbPageContentModelContentType];

export const Error404UmbPageContentModelContentType = {
	error404UmbPage: "error404UmbPage",
} as const;
